// EMs
const mq_breakpoints = {
	'--mobile-down': '(max-width: 25.99em)',
	'--mobile-up': '(min-width: 26em)',
	'--phablet-down': '(min-width: 32.49em)',
	'--phablet-up': '(min-width: 32.5em)',
	'--tablet-down': '(max-width: 39.99em)',
	'--tablet-up': '(min-width: 40em)',
	'--tablet-lg-down': '(min-width: 63.99em)',
	'--tablet-lg-up': '(min-width: 64em)',
	'--laptop-down': '(max-width: 71.99em)',
	'--laptop-up': '(min-width: 72em)',
	'--desktop-down': '(max-width: 99.99em)',
	'--desktop-up': '(min-width: 100em)',
	'--ultrawide': '(min-width: 125em)',
};

// Pixels
const px_breakpoints = {
	'--mobile-up': 416,
	'--phablet-up': 520,
	'--tablet-up': 640,
	'--tablet-lg-up': 1024,
	'--laptop-up': 1152,
	'--desktop-up': 1600,
	'--ultrawide': 2000,
};

export { mq_breakpoints, px_breakpoints };
